import {
  getBaseEndpointForAPIGateway,
  getBaseEndpointForMiniAppCore
} from '@/models/api/apiEnv';
import { GATEWAY_MODULE } from './gatewayModuleDefaultCn.js';
import { DetailPage } from '@/assets/marketplaces/cn/configs';
export const GATEWAY_MODULE_DEFAULT = GATEWAY_MODULE;
// externalPlatform params
export const EXTERNAL_PLATFORM = 'MiniApp';
export const GSAPP = 'GSApp';
// externalSellerId params
export const DEFAULT_KOL = 'default';
// userInteractionMethod params
export const USER_INTERACTION_METHOD = 'GS';
export const OUR_PRICE_TYPE = {
  DEAL: 'DEAL',
  BUYING: 'BUYING'
};
export const DOCUMENT_TITLE = 'Amazon  Global Stores Purchase';
// Judge the status of goods
export const AVAILABILITY_STATUS_ENUM = Object.freeze({
  IN_STOCK: 'IN_STOCK', // In stock
  IN_STOCK_SCARCE: 'IN_STOCK_SCARCE', // Scarce stock
  UNKNOWN_AVAILABILITY: 'UNKNOWN_AVAILABILITY',
  OUT_OF_STOCK: 'OUT_OF_STOCK' // Out of stock, currently out of stock
});
export const CURRENCY_SYMBOL = '￥';
// Activity type
export const REF_MARKER_ABBR = Object.freeze({
  DEAL_OF_THE_DAY: 'DEAL_OF_THE_DAY', // Discount price
  BEST_DEAL: 'BEST_DEAL' // Special selling price
});
export const DEAL_OFFER_STATE = {
  AVAILABLE: 'AVAILABLE',
  UPCOMING: 'UPCOMING',
  WAITLIST: 'WAITLIST',
  WAITLISTFULL: 'WAITLISTFULL',
  UNKNOWN: 'UNKNOWN'
};
export const GSAPP_RW_SESSION_KEY = 'rwSession';
export const ASSOCIATES_HANDLER_HORIZONTE_URL =
  '/amazon-cn/gs/rw/gp/miniapp/associates/handler.html';

// Search the list of thinning blocks
export const SEARCH_REFINMENT_BLOCK_LIST = [
  'Amazon  Global Stores Purchase',
  'Online preview',
  'Delivery',
  'Amazon Global Delivery',
  'Stock status',
  'Imported goods',
  'Country of origin',
  'Bonded warehouse|Hong Kong warehouse shipping',
  'Amazon Prime',
  'Prime Reading',
  'Seller',
  'Applicable for Kindle Unlimited monthly e-books',
  'Amazon Prime membership services'
];

export const CATEGORY_REFINEMENT_ID_LIST = ['i', 'n'];

export const REFINEMENTID_TO_ABBR = new Map([
  ['i', 'cat'],
  ['n', 'cat'],
  ['p_89', 'brand'],
  ['p_n_specials_match', 'discount']
]);

export const IMAGE_URL =
  'https://m.media-amazon.com/images/G/28/GlobalStoreMobileShoppingWebapp/';

export const NEW_IMAGE_URL = 'https://m.media-amazon.com/images/G/28/NewApp/';

export const SUCCESS_ICON_IMAGE_URL =
  'https://m.media-amazon.com/images/G/28/NewApp/10_Assets/00_Toolkits/Toolkits_Changeover_success_3x.png';

export const MY_AVATAR =
  'https://m.media-amazon.com/images/G/28/NewApp/10_Assets/02_Avatar/Avatar_Myaccount_img_3x.png';

export const TWISTER_DIMESIN_KEYS = {
  SIZE_NAME: 'size_name',
  COLOR_NAME: 'color_name',
  FLAVOR_NAME: 'flavor_name',
  STYLE_NAME: 'style_name'
};

// Usually, the second ancestor is redundant. like ["玩具", "类别", "钱包、提包"], we use this array to filter the redundant ancestor.
export const CATEGORY_REFINEMENT_ANCESTOR_BLOCK_LIST = [
  'Category',
  'Type',
  'Product'
];

// The badgeName field needs to be displayed on the product details page
export const MERCHANT_BADGE_REFINEMENT_MAP = Object.freeze({
  1827360071: {
    name: 'US',
    badgeName: 'US ',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`
  },
  1844252071: {
    name: 'UK',
    badgeName: 'UK',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`
  },
  1879515071: {
    name: 'JP',
    badgeName: 'JP',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`
  },
  1901313071: {
    name: 'GE',
    badgeName: 'GE',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`
  }
});

export const SOURCEMARKPLACEID_MERCHANT_BADGE_MAP = Object.freeze({
  1: {
    name: 'US',
    badgeName: 'US ',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`
  },
  3: {
    name: 'UK',
    badgeName: 'UK',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`
  },
  6: {
    name: 'JP',
    badgeName: 'JP',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`
  },
  4: {
    name: 'GE',
    badgeName: 'GE',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`
  }
});

// Icon management needs to match the corresponding icon data according to merchantId
export const MERCHANT_BADGE_MAP = Object.freeze({
  A2EDK7H33M5FFG: {
    name: 'US',
    badgeName: 'US ',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`,
    iconURL: 'US.png'
  },
  A3TEGLC21NOO5Y: {
    name: 'UK',
    badgeName: 'UK',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`,
    iconURL: 'UK.png'
  },
  A26HDXW89ZT98L: {
    name: 'JP',
    badgeName: 'JP',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`,
    iconURL: 'JP.png'
  },
  A3CQWPW49OI3BQ: {
    name: 'GE',
    badgeName: 'GE',
    badgeURL: `${NEW_IMAGE_URL}00_EN/Badge_nonarch3x.png`,
    iconURL: 'GE.png'
  }
});
export const SUCCESS_STATUS_CODE = 'SUCCESS';

// Pledge roll
export const NEW_COMER_WELFARE_FULL = 300;

// Newcomer deduction
export const NEW_COME_WELFARE_REDUCTION = 20;

export const COUPON_SERVICE_PROMOTION_STATUS = Object.freeze({
  ACTIVE: 'ACTIVE',
  REDEEMED: 'REDEEMED',
  USED: 'USED',
  EXHAUSTED: 'EXHAUSTED',
  UNAVAILABLE: 'UNAVAILABLE'
});

export const COUPON_SUB_TYPE = Object.freeze({
  BUY_X_GET_Y_OFF: 'buyXGetYOff',
  FST0: 'fst0'
});

export const ENCRYPTED_MARKETPLACE_ID = 'AAHKV2X7AFYLW';

// Add cart and Favorites to return status
export const ADD_CART_AND_FAVORITES_STATUS = Object.freeze({
  SUCCESSFUL: 0, // Add successfully
  FAILURE: -1, // Add failure
  EXCEED_MAX_LIMIT: -2, // Exceed maximum limit
  SINGLE_PRODUCT_EXCEED_MAX_LIMIT: -3 // Single product exceeds maximum limit
});
export const ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP = {
  AAHKV2X7AFYLW: 'zh-CN',
  ATVPDKIKX0DER: 'en-US'
};
export const marketPlaceLocaleApiMap = {
  AAHKV2X7AFYLW: 'zh_CN',
  ATVPDKIKX0DER: 'en_US'
};
export const marketPlaceAddressMap = {
  AAHKV2X7AFYLW: 'China'
};
export const marketPlaceStyleMap = { AAHKV2X7AFYLW: 'cn', ATVPDKIKX0DER: 'en' };

// Display the first level page of the tab bar, and judge the shopping cart page separately
export const TAB_BAR_ROUTER_NAME = ['gateway', 'category', 'yourAccount'];

export const CLIENT_ID_LIST = ['MiniApp', 'GSApp'];
export const CLIENT_ID = 'GSApp';

export const TEXT_REG = /[\u4e00-\u9fa5]/g;
// Time stamp to time
export const formatTimestamp = function (
  timeStamp,
  type = 'time',
  joinStr = '-'
) {
  if (!timeStamp) return '';
  if (typeof timeStamp === 'string') {
    timeStamp = parseInt(timeStamp, 10);
  }
  const currdate = new Date(timeStamp * 1000);
  const year = currdate.getFullYear();
  const month = currdate.getMonth() + 1;
  const day = currdate.getDate();
  const hour = currdate.getHours();
  const minute = currdate.getMinutes();
  const second = currdate.getSeconds();

  if (type === 'date') {
    return [year, month, day].map(n => n.toString()).join(joinStr);
  }
  return `${[year, month, day].map(n => n.toString()).join('/')} ${[
    hour,
    minute,
    second
  ]
    .map(n => n.toString())
    .join(':')}`;
};
export const NON_RETURNABLE_FLAG = {
  TRUE: '0',
  FALSE: '1'
};
export const MERCHANT_ID_TO_NAME_MAP = Object.freeze({
  // Only US are supported in Infinity P0
  A2EDK7H33M5FFG: 'US'
});
export const UNREAD_QUANTITY_RANGE = 99; // The maximum value displayed for unread messages
export const UNREAD_QUANTITY_RANGE_MARK = '99+'; // Mark greater than 99
export const NOTIFICATION_ITEMS_QUANTITY_THRESHOLD_PER_PAGE = 20; // notificationItem page size

export const PAYMENT_LIST = [
  {
    icon: `${IMAGE_URL}assets/svg/wechat.svg`,
    text: 'WeChat Pay',
    id: 1,
    type: 'WeChat'
  }
];
export const CUSTOMER_CONSENT_AUTH_GRANTED = 'granted';
export const CUSTOMER_CONSENT = {
  FALSE: 'OptOut',
  TRUE: 'OptIn'
};
export const MARKET_PLACE_ID = 3240;
const ERROR_CODE_ASIN_OUT_OF_STOCK = 'OMS_508';
const ERROR_CODE_UNKNOWN = 'PCE_502_0';
const ERROR_CODE_ADDRESS = 'PCE_502_1';
const ERROR_CODE_STOCKS = 'PCE_503_2';

const CV_FRAUD = 'FRAUD';
const CV_EXCEEDED_PERMITTED_QUANTITY = 'EXCEEDED_PERMITTED_QUANTITY';
const CV_EXCEEDED_AVAILABLE_QUANTITY = 'EXCEEDED_AVAILABLE_QUANTITY';
const CV_NO_MORE_ORDERING_UNITS = 'NO_MORE_ORDERING_UNITS';

export const ERROR_CODE_INVALID_SESSION_ID = 'SESSION_001';

export const CV_LEGACY_ADDRESS_IN_USE = 'LEGACY_ADDRESS_IN_USE';
export const CV_ADDRESS_NOT_REACHED = 'ADDRESS_NOT_REACHED';
export const CV_CONSENT_NOT_GRANT = 'CONSENT_NOT_GRANT';
export const CV_QUANTITY_LIMITS = 'QUANTITY_LIMITS';
export const CV_QUANTITY_NOT_AVAILABLE = 'QUANTITY_NOT_AVAILABLE';
export const CV_CUSTOMER_CONSENT_NOT_GRATED = 'CUSTOMER_CONSENT_NOT_GRATED';
export const CV_INVALID_COUPON_BALANCE = 'INVALID_COUPON_BALANCE';
export const CV_DEPENDENCY_EXCEPTION = 'DEPENDENCY_EXCEPTION';

// set address
export const CV_DELIVERY_INFO_MISSING = 'DELIVERY_INFO_MISSING';
export const CV_CANT_SHIP_TO_ADDRESS = 'CANT_SHIP_TO_ADDRESS';
export const CV_CANT_SHIP_3P_CONFIDENTIAL = 'CANT_SHIP_3P_CONFIDENTIAL';
export const CV_INVALID_SHIPPING_SPEED = 'INVALID_SHIPPING_SPEED';
export const CV_NEED_DIFFERENT_SHIPPING_SPEED = 'NEED_DIFFERENT_SHIPPING_SPEED';

export const CV_KYC_DOCUMENT_UPLOAD_REQUIRED_CONSTRAINT_VIOLATION =
  'KycDocumentUploadRequiredConstraintViolation';
export const CV_KYC_IDENTIFICATION_NOT_VALID_CONSTRAINT_VIOLATION =
  'KycIdentificationNotValidConstraintViolation';
export const CV_STATS_SUFFIX_ARRAY = [
  'HANDLE',
  'CREATE_ORDER',
  'SIGN_ORDER',
  'ORDER_AMOUNT'
];
export const ERROR_MESSAGE_MAPPING = new Map([
  [ERROR_CODE_UNKNOWN, 'unknownCV'],
  [ERROR_CODE_ADDRESS, 'Address unreachable'],
  [
    ERROR_CODE_STOCKS,
    'Some items are out of stock, we have updated the quantity for you'
  ],
  [CV_FRAUD, 'User locked'],
  [CV_EXCEEDED_PERMITTED_QUANTITY, 'Exceeded the allowed ordering quantity'],
  [CV_EXCEEDED_AVAILABLE_QUANTITY, 'Some items are out of stock'],
  [
    ERROR_CODE_ASIN_OUT_OF_STOCK,
    'Some items are currently out of stock, please re-select to order'
  ],
  [CV_NO_MORE_ORDERING_UNITS, 'Some items have sold out'],
  [
    ERROR_CODE_INVALID_SESSION_ID,
    'Order creation failed, please log out and try again'
  ]
]);
export const CV_SIGN_PRIORITY_MAP = new Map([
  [CV_FRAUD, 100],
  [CV_NO_MORE_ORDERING_UNITS, 90],
  [CV_EXCEEDED_AVAILABLE_QUANTITY, 80],
  [CV_EXCEEDED_PERMITTED_QUANTITY, 70]
]);
export const FREE_SHIPPING_PROMOTION = [
  'Free international shipping',
  'Free shipping',
  'Free postage'
];
export const SELECTION_TYPE = {
  INSTEAD_SELECT: 'InsteadSelect',
  MULTI_SELECT_OR: 'MultiSelectOR',
  MULTI_SELECT_AND: 'MultiSelectAND'
};
export const SEARCH_IMAGE_RESOLUTION = 300;
export const ORDER_EXTERNAL_REQUEST_ID_LENGTH = 15;
// Display key value pairs for tab bar pages
export const TABBAR_PAGE_APP_CODE = {
  GATEWAY: 0,
  CATEGORY: 1,
  CART: 2,
  YOURACCOUNT: 3
};
export const RETAIL_MERCHANT_ID = 'A1AJ19PSB66TGU';
export const PUBLIC_KEY = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAi+rzIkpSm1HO3OdryJa83vlQEg1KCsky7MASrzL4NTKTcYSQOOcWoBihJI+2T6TaBn+67B4EojvNSDAIdikS9L5hisZ4mif/AHpHV/eEznAitKHiux61A1fCFwE/HqzL+pm3DR/KVcVJRLBaqhvk/r42uLKRImXGJgxD0ucADF9EqdCqEfn66sFdlxRo7bJU6RBQ7UqGw3RW9tnOX7r+tHlwQ+HlAS2vtotmmWWIiXiVBcJ9TJvTGglC/kmizYmirvRj+lBdk9DXHVqcB+f3GTGsXHZ6peGUq35l4YCHal4TKrlrrHATpZJyn52sMCPhS1oTlRaf83nTQd3nqUVD3wIDAQAB`;
export const PUBLIC_KEY_STRING = `-----BEGIN PUBLIC KEY-----\n${PUBLIC_KEY}\n-----END PUBLIC KEY-----`;
export const ENCRYPT_MAX_LENGTH = 117;
export const PAY_STATUS_RESULT = {
  PAYSUCCESS: 0,
  PAYCANCEL: -1,
  PAYERROR: -2,
  ABNORMAL: -3
};
export const IMAGE_DOMAIN_CN = 'images-cn.ssl-images-amazon.cn';
export const IMAGE_PREFIX_ON_FULL_PATH = `https://${IMAGE_DOMAIN_CN}`;
export const IMAGE_PREFIX_ON_PARTIAL_PATH = `https://${IMAGE_DOMAIN_CN}/images/G/28`;

export const AD_PREFERENCE_DATA = [
  {
    TITLE: 'Amazon advertising preferences',
    CONTENT:
      "Allow Amazon's pushed advertisements to provide personalized processing",
    SWITCH: true
  },
  {
    TITLE: 'What is personalized advertising？',
    CONTENT:
      'Personalized advertising, sometimes also called targeted advertising or interest-based advertising, is based on relevant information about you, for example, the products you browse or purchase on Amazon  Global Stores Purchase and its affiliated websites, your visits to websites where we advertise or content, or your use of services like Checkout by Amazon on other websites. You can set your preferences here for personalized ads processed by Amazon, or visit our interest-based advertising page for more information.'
  }
];
export const TIME_FORMAT_BY_HOUR = 'h:m:s';
export const TIME_FORMAT_BY_DAY = 'Dd h:m:s';
export const YA_ORDER_TABS = [
  {
    ICON: `${IMAGE_URL}assets/svg/backIcon.svg`,
    KEY: 'noShipmentCount',
    PATH: 'yoOrderList',
    PARAMS: 2,
    NAME: 'To be shipped'
  },
  {
    ICON: `${IMAGE_URL}assets/svg/transportingIcon.svg`,
    KEY: 'deliveryingCount',
    PATH: 'yoOrderList',
    PARAMS: 3,
    NAME: 'To be received'
  },
  {
    ICON: `${IMAGE_URL}assets/svg/criticizeIcon.svg`,
    KEY: 'toBeCommentedCount',
    PATH: 'yoCustomerReview',
    PARAMS: '',
    NAME: 'To be reviewed'
  },
  {
    ICON: `${IMAGE_URL}assets/svg/refundIcon.svg`,
    KEY: 'afterSaleCount',
    PATH: 'asList',
    PARAMS: '',
    NAME: 'Returns'
  },
  {
    ICON: `${IMAGE_URL}assets/svg/indentIcon.svg`,
    KEY: 'totalOrderCount',
    PATH: 'yoOrderList',
    PARAMS: 1,
    NAME: 'My orders'
  }
];
export const YA_COMMON_LINKS = [
  [
    {
      ICON: `${IMAGE_URL}assets/svg/couponIcon.svg`,
      PATH: 'couponsList',
      NAME: 'Coupons'
    },
    {
      KEY: 'todayDeal',
      ICON: `${IMAGE_URL}assets/svg/treasureIcon.svg`,
      PATH: 'todayDeal',
      NAME: "Today's deals"
    },
    {
      KEY: 'bestSellingRecommendations',
      ICON: `${IMAGE_URL}assets/svg/rankingIcon.svg`,
      PATH: '',
      NAME: 'Top ranking'
    }
  ],
  [
    {
      ICON: `${IMAGE_URL}assets/svg/icon/icon_yourAccount_address.svg`,
      PATH: 'addressList',
      NAME: 'Delivery address'
    },
    {
      ICON: `${IMAGE_URL}assets/svg/icon/icon_yourAccount_identity.svg`,
      PATH: 'kycList',
      NAME: 'Customs clearance'
    },
    {
      ICON: `${IMAGE_URL}assets/svg/icon/icon_yourAccount_service.svg`,
      PATH: 'contactCS',
      NAME: 'Customer service'
    },
    {
      KEY: 'businessLicense',
      ICON: `${IMAGE_URL}assets/svg/icon/icon_yourAccount_business.svg`,
      PATH: 'businessLicense',
      NAME: 'Licenses'
    }
  ]
];
export const VERIFY_PHONE_NUMBER_REGEX = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
export function checkCNIDCardFormat(citizenID) {
  const CN_CITIZEN_ID_LENGTH = 18;
  const CN_CHECKBIT_START_INDEX = 17;
  const CN_DIVISOR = 11;
  const CN_FORMAT_REGEX = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  const CN_WEIGHTS = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const CN_CHECK_BITS = [
    '1',
    '0',
    'x',
    '9',
    '8',
    '7',
    '6',
    '5',
    '4',
    '3',
    '2',
    '1'
  ];
  if (!citizenID || citizenID.length !== CN_CITIZEN_ID_LENGTH) {
    return false;
  }
  if (!CN_FORMAT_REGEX.test(citizenID)) {
    return false;
  }
  const strExpectedCheckBit = citizenID.substring(CN_CHECKBIT_START_INDEX);
  let sum = 0;
  for (let i = 0; i < CN_WEIGHTS.length; i++) {
    const weight = CN_WEIGHTS[i];
    const bit = parseInt(citizenID.substring(i, i + 1), 10);
    sum += weight * bit;
  }
  const remainder = sum % CN_DIVISOR;
  const strCalculatedCheckBit = CN_CHECK_BITS[remainder];
  if (
    strExpectedCheckBit.toLowerCase().valueOf() ===
    strCalculatedCheckBit.toLowerCase().valueOf()
  ) {
    return true;
  }
  return false;
}
export const INTERACTION_TYPE = {
  ROUTE_PAGE_TYPE: {
    INTERNAL: '跳转内部页面',
    CUSTOM: '自定义跳转',
    PROMOTION_CUSTOMIZATION: '促销定制页'
  },
  // Route from internal page to secondary internal page
  SECONDARY_INTERNAL_PAGE_TYPE: {
    HOME: '首页',
    PRODUCT_LIST: '商品列表',
    CATEGORIZE: '分类页',
    PERSONAL_CENTER: '个人中心',
    CART: '购物车',
    ORDER_LIST: '订单列表',
    SEARCH: '搜索',
    SECONDARY_ACTIVITIES: '二级活动页'
  }
};

export const AREA_CODE = '+86';
export const ADVERTISING_SOURCE_PAGE = {
  DP: 1,
  PAYSUCCESS: 2,
  CATEGORY: 3,
  PROMOTION: 4
};
export const ENUM_APP_CONFIG_TYPE = {
  SETTING_PAGE: 'settingPage',
  CART_PAGE: 'cartPage',
  CHECKOUT_PAGE: 'checkoutPage',
  DETAIL_PAGE: 'dpPage'
};
export const ACCOUNT_SETTINGS_LIST = [
  [
    {
      TITLE: 'Manage address information',
      PATH: 'addressList'
    },
    {
      TITLE: 'Manage ID',
      DESCRIBE: 'Used for customs clearance in  Global Store purchases',
      PATH: 'kycList'
    }
  ],
  [
    {
      TITLE: 'Manage my authorization',
      PATH: 'authorizationManagement'
    },
    {
      TITLE: 'Advertising preference settings',
      PATH: 'adPreference'
    },
    {
      TITLE: 'Personalized content recommendation',
      PATH: 'personalizedRecommendation'
    },
    {
      TITLE: 'Notification settings',
      PATH: 'notificationReminder'
    }
  ],
  [
    {
      TITLE: 'Privacy and Security',
      PATH: 'privacySecurity'
    },
    {
      TITLE: 'Clear cache',
      CACHE_SIZE_TYPE: true,
      PATH: ''
    },
    {
      TITLE: 'About the App',
      CURRENT_APP_VERSION: true,
      PATH: 'aboutApp'
    }
  ]
];
export const PRIVACY_SECURITY_LIST = [
  {
    TITLE: 'Privacy statement',
    PATH: 'termStatement',
    PARAMS: 'PRIVACY_STATEMENT'
  },
  {
    TITLE: 'Terms of use',
    PATH: 'termStatement',
    PARAMS: 'USE_CONDITION'
  },
  {
    TITLE: 'Amazon  Global Stores Purchase terms of use',
    PATH: 'termStatement',
    PARAMS: 'USE_CONDITION_FOR_AGS'
  },
  {
    TITLE: 'Amazon  Global Stores entity registration information',
    PATH: 'termStatement',
    PARAMS: 'OVERSEAS_ENTITY_REGISTRATION_INFO'
  },
  {
    TITLE: 'Get my data',
    DESCRIPTION: 'Get all the data I generated on Amazon',
    PATH: 'https://www.amazon.cn/hz/privacy-central/data-requests/preview.html?nativeTitle=获取我的数据&isHideTopNavBar=0'
  },
  {
    TITLE: 'Cancel account',
    PATH: 'deleteAccount'
  }
];
export const MOBILE_PHONE_MAX_LENGTH = 11; // Maximum length of mobile phone number
export const CS_HOTLINE = '4009105680';
export const CS_FAQ_URL =
  'https://api-cslp-emt.amazon.cn/gateway/cs/getFaqPage?nativeTitle=亚马逊联系我&isHideTopNavBar=0';

export const CN_GSAPP_DOWNLOAD_URL_ENUM = {
  iOS: 'itms-apps://itunes.apple.com/cn/app/id342576766?mt=8',
  Android:
    'https://sj.qq.com/appdetail/cn.amazon.mShop.android?fromcase=70051&g_f=1182517&scenevia=XQYFX&from_wxz=1'
};

export const AUTH_ORDER_URL =
  'https://www.amazon.cn/gp/help/customer/display.html/ref=ags_checkout_cou?ie=UTF8&nodeId=201625060';
export const SHARE_MODULE = {
  SHARE_TYPE: { shareLink: 'wx_link', shareImage: 'wx_image' },
  BTN_TYPE_FUNC: {
    shareWechat: 'handleShareWeChat',
    generateImages: 'handleGenerateImages',
    saveImages: 'handleSaveImages'
  },
  IMG_URL: {
    WECHAT_URL: `${IMAGE_URL}assets/svg/icon/Wechat.svg`,
    GENERATE_IMAGES_URL: `${IMAGE_URL}assets/svg/icon/GenerateImg.svg`,
    SAVE_IMAGES_URL: `${IMAGE_URL}assets/svg/icon/SaveImg.svg`
  },
  MAX_PIC_NUM: 6,
  WEBAPP_PROD_SUBDOMAIN: 'https://globalstore.amazon.cn',
  shareRouter: {
    DETAIL_PAGE: 'detailPage',
    GATEWAY: 'gateway',
    DOWNLOAD: 'download',
    LANDING_PAGE: 'landingPage'
  }
};
export const GATEWAY_MODULES_DEFAULT = {
  WIDGETS: [
    {
      categoryType: 'imageBanner',
      widgetCategoryTitle: '图片广告',
      isShow: 'DISPLAY',
      sort: 23,
      bottomSpacing: 12,
      layoutType: 'ENDTISE_TILED',
      spacing: 10,
      height: 175,
      interactionTypeInfo: [
        {
          interactionTypeId1: '3240#zh-CN_无',
          interactionTypeId2: '',
          interactionTypePath: '',
          conditionMatch: 'test',
          displayName: 'test',
          pageUrl: '',
          picUrl:
            'https://ka-sit.etocdn.cn/840/2023-09-20/840_20230920090928248317653633.png'
        }
      ]
    },
    {
      categoryType: 'imageBanner',
      widgetCategoryTitle: '图片广告',
      isShow: 'DISPLAY',
      sort: 22,
      bottomSpacing: 12,
      layoutType: 'ENDTISE_TILED',
      spacing: 10,
      height: 175,
      interactionTypeInfo: [
        {
          interactionTypeId1: '3240#zh-CN_Jump to internal page',
          interactionTypeId2: '3240#zh-CN_搜索',
          interactionTypePath: 'search',
          conditionMatch: 'test',
          displayName: 'test',
          pageUrl: '',
          picUrl:
            'https://ka-sit.etocdn.cn/840/2023-09-19/840_20230919164625425317527808.png'
        }
      ]
    }
  ]
};
export const DELETE_ACCOUNT_DESCRIPTION_LIST = [
  {
    PARAGRAPH:
      'You are about to submit a request to permanently cancel your Amazon account and delete your data. Once your account is canceled, you will no longer be able to use any products and services previously accessed through that account.',
    LINK_TEXT: 'Instructions for canceling an account'
  },
  {
    PARAGRAPH:
      'Once an account is canceled, it will no longer be available and cannot be recovered. If you decide to start ordering from us again later, or if you want to use products and services that require an account, you will need to create a new account.',
    LINK_TEXT: 'What happens after an account is canceled'
  },
  {
    PARAGRAPH:
      'If you have uploaded your own content in one of our services, please',
    LINK_TEXT: 'Get your information',
    PERIOD: true
  },
  {
    PARAGRAPH:
      'According to legal requirements, Amazon needs or has the right to retain certain types of data, such as order history. We will carry out the above operations in accordance with applicable legal regulations (including tax, accounting, and anti-fraud requirements).'
  },
  {
    PARAGRAPH:
      'If you continue to submit this request, you will not be able to use the products and services related to the canceled account, including:'
  }
];
export const DELETE_ACCOUNT_RELATED_SERVICE_LIST = [
  {
    ICON: `${IMAGE_URL}assets/setting_delete_account_amazon_logo1.png`,
    DESCRIPTION:
      'Your buyer profile, including your reviews, discussion posts, and order returns and refunds.'
  },
  {
    ICON: `${IMAGE_URL}assets/setting_delete_account_amazon_logo2.png`,
    DESCRIPTION:
      'Accounts associated with your Amazon Business account, as well as data related to that user on Amazon Business.'
  },
  {
    ICON: `${IMAGE_URL}assets/setting_delete_account_amazon_logo3.png`,
    DESCRIPTION: 'Amazon Affiliate Program account.'
  },
  {
    ICON: `${IMAGE_URL}assets/setting_delete_account_amazon_logo4.png`,
    DESCRIPTION: 'Your Prime membership.'
  },
  {
    ICON: `${IMAGE_URL}assets/setting_delete_account_amazon_logo5.png`,
    DESCRIPTION:
      'Your unused gift card balance will no longer be available. You will not be able to redeem any additional Amazon gift cards.'
  },
  {
    ICON: `${IMAGE_URL}assets/setting_delete_account_amazon_logo6.png`,
    DESCRIPTION:
      'Your Kindle content and subscriptions, as well as any notes or annotations created through your account.'
  }
];
export const DELETE_ACCOUNT_REASON_LIST = [
  {
    TITLE: 'I no longer use this account',
    VALUE: 'accountNotUsingReason'
  },
  {
    TITLE: 'I have another account',
    VALUE: 'otherAccountReason'
  },
  {
    TITLE: 'I want to create a new account',
    VALUE: 'newAccountReason'
  },
  {
    TITLE: 'Account security issue/unauthorized activity',
    VALUE: 'compromisedAccountReason'
  },
  {
    TITLE: 'Privacy issues',
    VALUE: 'privacyConcernsReason'
  },
  {
    TITLE: 'I have unresolved issues with Amazon',
    VALUE: 'openIssuesReason'
  },
  {
    TITLE: 'I do not want to provide a reason',
    VALUE: 'notApplicableReason'
  }
];
export const DELETE_ACCOUNT_STATUS_MAPPING = {
  PROCESSING: {
    TITLE: 'The request to cancel the Amazon account is being processed',
    CONTENT:
      'Your request to cancel the Amazon account and delete the data has been confirmed and is being processed.'
  },
  CONFIRM_CONSENT_EXPIRED: {
    TITLE: 'Cancel Amazon account',
    CONTENT: 'Your application has expired, please reapply.'
  },
  UNKNOWN_FAILURE: {
    TITLE: 'Cancel Amazon account',
    CONTENT: 'The system is upgrading, please try again later.'
  }
};
export const DELETE_ACCOUNT_CANCEL_REASON_MAPPING = {
  CANCEL_CONSENT_EXPIRED: 'Your application has expired, please reapply',
  CANCEL_CONSENT_ALREADY_CANCELED:
    'You have canceled the cancellation, no need to submit again',
  UNKNOWN_FAILURE: 'The system is upgrading, please try again later'
};
export const DELETE_ACCOUNT_KNOWN_DEPENDENCIES = {
  OPEN_ORDERS: 'Order in progress',
  OPEN_REFUNDS: 'Order returning',
  DSAR: 'Personal data application',
  GS_OPEN_ORDERS: 'APP order in progress',
  GS_OPEN_REFUNDS: 'APP order returning',
  GS_DSAR: 'APP personal data application'
};
export const TERMINATION_OF_DELETE_STATUS_MAPPING = {
  CANCEL_REQUEST_ALREADY_CANCELED:
    'You have canceled the cancellation, no need to submit again',
  UNKNOWN_FAILURE: 'The system is upgrading, please try again later'
};

export const API_LIST = {
  EMTCSLP_EXTERNAL_APIGATEWAY_PROD: getBaseEndpointForAPIGateway(),
  EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA: getBaseEndpointForAPIGateway('gamma'),
  MINIAPP_PROD: getBaseEndpointForMiniAppCore(),
  MINIAPP_GAMMA: getBaseEndpointForMiniAppCore('gamma')
};
export const APP_PAGE_CONFIG_PAGES_ENUM = {
  SETTING_PAGE: 'settingPage',
  CART_PAGE: 'cartPage',
  CHECKOUT_PAGE: 'checkoutPage',
  DETAIL_PAGE: 'dpPage'
};
export const BOTTOM_BAR_BUTTON_COLORS = {
  CONFIRM_INFO_COLOR: '#FF6E70',
  PRICE_ACTION_COLOR: '#EB1745'
};
export const DETAIL_PAGE_COUPON_STYLE = {
  BACKGROUND_COLOR_BEFORE: '#FFF7F5',
  BACKGROUND_COLOR_AFTER: '#FFF7F5',
  TEXT_COLOR_BEFORE: '#FF4D5B',
  TEXT_COLOR_AFTER: '#FF4D5B',
  ASIN_INFO_COUPON_TEXT_COLOR: '#FF680D'
};
export const GET_MY_DATA_DESCRIPTION_TEXT_LIST = [
  {
    DESCRIPTION:
      'My account contains a large amount of personal data that you can access. Please select the data you want, by submitting an application to get the personal data that is not accessible in my account or device.'
  },
  {
    DESCRIPTION:
      'For more information about the types of data about you, please click',
    TEXT: 'Amazon and My Data'
  },
  {
    DESCRIPTION:
      'Once your request is processed, we will send you a secure download link by email.。'
  }
];

export const DATA_PROFILE_ID = {
  RETAIL: 'retail'
};
export const GET_MY_DATA_REQUEST_PROMPT_TEXT = {
  CEATE_PENDING_CONFIRMATION:
    'Application sent, please check your mail & SMS for confirmation',
  CEATE_PENDING_DELIVERY:
    'Data provided, please pay attention to your email and SMS',
  UNKNOWN_FAILURE: 'Submission failed, please resubmit'
};
export const GET_MY_DATA_CONFIRMATION_PROMPT_TEXT = {
  CONFIRM_PAGE_ALREADY_CONFIRMED:
    'Data request confirmed, no need to confirm again',
  CONFIRM_PAGE_DELIVERED:
    'Data provided, please pay attention to your email and SMS',
  CONFIRM_PAGE_LINK_EXPIRED:
    'Data has expired, please resubmit the application',
  UNKNOWN_FAILURE: 'Confirmation failed, please reconfirm'
};

export const DP_AMAZON_GS_TIPS = [
  {
    TITLE: 'Product and service differences',
    CONTENT: [
      'Products purchased from Amazon  Global Stores Purchase are sold by  Global Stores Amazon websites and are subject to the laws, regulations, standards, norms, and practices of the country where the foreign website is located. Therefore, they may differ in the following respects from products sold within China:',
      `Sizes: <a data-title='${DetailPage.DP_AMAZON_TIPS_KEY.SIZE_CHART}'>Shoe and Clothing Size Chart</a>, <a data-title='${DetailPage.DP_AMAZON_TIPS_KEY.UNIT_CONVERSION}'>Unit Conversion Chart</a>. Note: If the selling brand provides a specific size chart, please refer to the brand's size chart.`,
      `Voltage and Power Sockets: Electronic products may not support China's voltage environment, power sockets, and other specification standards, and may require the use of transformers or adapters. <a data-title='${DetailPage.DP_AMAZON_TIPS_KEY.ELECTRICAL_VOLTAGE}'>Tips for Electrical Power Use</a>.`,
      `Shelf Life of Beauty Products: The labeling of the production date/shelf life of beauty products may differ from products purchased through domestic channels. See <a data-title='${DetailPage.DP_AMAZON_TIPS_KEY.BEAUTY_SHOPPING}'>Tips for Purchasing Beauty Products</a> for details.`,
      "After-Sales Service: After-sales warranty for products from Amazon  Global Stores Purchase is provided by the brand merchants of the original sales location of the foreign website. Such warranties and other after-sales services may not cover China. For details, please contact the brand merchant's after-sales service.",
      'Labels, Manuals, and Instruction Books: Labels, manuals, and instruction books are not translated into Chinese; the ingredients, claims, product descriptions, reference values, and recommended values may differ from Chinese standards or practices.',
      'Other: Due to differences in demographics (especially children, the elderly, and the disabled), usage environment, consumption scenarios, and habits between the place of sale and the place of use, the product may not be suitable or fully suitable for its intended purpose.'
    ]
  },
  {
    TITLE: 'Customs Clearance Service',
    CONTENT: [
      `According to the requirements of Chinese customs, when purchasing products from Amazon  Global Stores Purchase, you will need to submit the identity card information of the orderer (currently only supporting verification of Chinese resident identity card information) for customs clearance. <a data-title='${DetailPage.DP_AMAZON_TIPS_KEY.CUSTOMS_CLEARANCE}'>Click here for details</a>.`,
      'Amazon will never ask for your bank card number, verification code, or any other such information for any reason. If criminals impersonating Amazon  Global Stores Purchase customer service ask for your bank account information, please contact Amazon  Global Stores Purchase customer service or the police in a timely manner and remain vigilant.'
    ]
  },
  {
    TITLE: 'Logistics and Delivery：',
    CONTENT: [
      'Products from Amazon  Global Stores Purchase comply with customs import and export policy requirements and support delivery throughout China, excluding Hong Kong, Macau, and Taiwan. However, delivery times may be extended for some remote areas, and a few products do not support delivery. If you have successfully placed an order and we are unable to deliver to you, we will notify you in time.'
    ]
  },
  {
    TITLE: 'Other：',
    CONTENT: [
      'Global Stores products sold by Amazon  Global Stores Purchase are for personal use only. Purchasing behavior must follow the principles of personal use and reasonable quantity and must not be turned into other commercial purposes or resold.'
    ]
  }
];

export const PROTOCOL_TITLE_MAPPING = {
  PRIVACY_STATEMENT: 'modules["customerProtocols.privacySecurity"].TITLE',
  USE_CONDITION: 'modules["customerProtocols.useCondition"].TITLE',
  USE_CONDITION_FOR_AGS:
    'modules["customerProtocols.useConditionForAGS"].TITLE',
  COOKIES_POLICY: 'modules["customerProtocols.cookiesPolicy"].TITLE',
  ADVERTISEMENT: 'modules["customerProtocols.advertisement"].TITLE',
  COMMUNITY_GUIDELINES:
    'modules["customerProtocols.communityGuidelines"].TITLE',
  INTERNATIONAL_DELIVERY:
    'modules["customerProtocols.internationalDelivery"].TITLE',
  PERMISSION_DESCRIPTION:
    'modules["customerProtocols.appPermissionStatement"].TITLE',
  PERSONAL_INFORMATION:
    'modules["customerProtocols.persInfoCollectionChecklist"].TITLE',
  SDK: 'modules["customerProtocols.sdk"].TITLE',
  TRADEMARK: 'modules["customerProtocols.trademark"].TITLE',
  UNIT_CONVERSION_TABLE: DetailPage['default'].unitConversion.TITLE,
  ELECTRICAL_VOLTAGE_USAGE_INSTRUCTION:
    DetailPage['default'].electricalVoltage.TITLE,
  BEAUTY_SHOPPING_GUIDE: DetailPage['default'].beautyShopping.TITLE,
  CUSTOMS_CLEARANCE_INFO: DetailPage['default'].customsClearanceInfo.TITLE,
  OVERSEAS_ENTITY_REGISTRATION_INFO:
    'modules["customerProtocols.overseasEntityRegistrationInfo"].TITLE'
};
export const PROTOCOL_MAPPING = {
  PRIVACY_STATEMENT: 'modules["customerProtocols.privacySecurity"].CONTENT',
  USE_CONDITION: 'modules["customerProtocols.useCondition"].CONTENT',
  USE_CONDITION_FOR_AGS:
    'modules["customerProtocols.useConditionForAGS"].CONTENT',
  COOKIES_POLICY: 'modules["customerProtocols.cookiesPolicy"].CONTENT',
  ADVERTISEMENT: 'modules["customerProtocols.advertisement"].CONTENT',
  COMMUNITY_GUIDELINES:
    'modules["customerProtocols.communityGuidelines"].CONTENT',
  INTERNATIONAL_DELIVERY:
    'modules["customerProtocols.internationalDelivery"].CONTENT',
  PERMISSION_DESCRIPTION:
    'modules["customerProtocols.appPermissionStatement"].CONTENT',
  PERSONAL_INFORMATION:
    'modules["customerProtocols.persInfoCollectionChecklist"].CONTENT',
  SDK: 'modules["customerProtocols.sdk"].CONTENT',
  TRADEMARK: 'modules["customerProtocols.trademark"].CONTENT',
  UNIT_CONVERSION_TABLE: DetailPage['default'].unitConversion.CONTENT,
  ELECTRICAL_VOLTAGE_USAGE_INSTRUCTION:
    DetailPage['default'].electricalVoltage.CONTENT,
  BEAUTY_SHOPPING_GUIDE: DetailPage['default'].beautyShopping.CONTENT,
  CUSTOMS_CLEARANCE_INFO: DetailPage['default'].customsClearanceInfo.CONTENT,
  OVERSEAS_ENTITY_REGISTRATION_INFO:
    'modules["customerProtocols.overseasEntityRegistrationInfo"].CONTENT'
};
export const OFFICIAL_APP_FILING_URL =
  'https://beian.miit.gov.cn?isHideTopNavBar=0';
export const API_MAX_ASINS_LENGTH = 20;
